/* globals angular, _, $ */
(function() {
  'use strict';

  function ReverseListCtrl($scope, $rootScope, $state, $mdPanel, $mdToast, $mdSidenav, $filter, $q, $uibModal,
    $timeout, Historico, PrintLabel, Pedido, localStorageService, IntegrationService,
    Rastreamento, Perfil, $tour, $stateParams) {

    if ( $rootScope.msgSuccessReverse ) {
      $rootScope.msgSuccessReverse = false;
      _showAlert("A autorização de postagem foi solicitada à transportadora. Quando o código de postagem for gerado, enviaremos para o e-mail informado.");
    }

    var $ctrl = this;

    $ctrl.table = {
      config: {
        rowSelection: false,
        multiSelect: true,
        autoSelect: true,
        reverses: [],
        selected: [],
        page: 1,
        pages: null,
        limitPerPage: 100,
        loading: {
          page: null,
          btnLoading: null,
          printLabels: null
        },
        showBtnLoading: null
      }
    };


    Perfil.getClienteData(localStorageService.get('user').id).then(function(user) {
      $ctrl.user = user;
    });

    $ctrl.table.reset = angular.copy($ctrl.table.config);

    $ctrl.panelDelay = null;

    $ctrl.filter = {
      global: {
        config: {
          select: {
            title: 'Select',
            options: [{
              name: 'cepRemetente',
              displayName: 'CEP do Remetente',
              code: 0
            }, {
              name: 'nomeRemetente',
              displayName: 'Nome do Remetente',
              code: 1
            }, {
              name: 'rastreamento',
              displayName: 'Rastreamento',
              code: 2
            }, {
              name: 'pedido',
              displayName: 'Número do pedido',
              code: 3
            }, {
              name: 'codigoTransportadora',
              displayName: 'Código da Transportadora',
              code: 4
            }],
            isSelected: {
              name: 'cepRemetente',
              displayName: 'CEP do Remetente',
              code: 0
            }
          },
          text: {
            title: 'Text',
            options: {
              name: 'content',
              displayName: 'Buscar por',
              code: '3',
              isText: null
            }
          }
        },
        current: null
      }
    };

    $ctrl.filter.reset = angular.copy($ctrl.filter.global);

    $ctrl.isOpenDetail = false;

    function enableDisableLoading (key, active) {
      var disableList = _.isArray(key) ? key : [key];
      var isActivated = active;
      _.forEach(disableList, function(loading) {
        _.forIn($ctrl.table.config.loading, function(value, key) {
          if (key === loading) {
            $ctrl.table.config.loading[key] = isActivated;
          }
        });
      });
    }

    function loadData() {
      var offset = $ctrl.table.config.page > 1 ? $ctrl.table.config.reverses.length : 0;
      var limit = $ctrl.table.config.limitPerPage;

      if($ctrl.table.config.page === 1) {
        $ctrl.table.config.reverses = [];
      }

      if($ctrl.filter.global.current && $ctrl.filter.global.current.cepRemetente) {
        $ctrl.filter.global.current.cepRemetente = $ctrl.filter.global.current.cepRemetente.replace(/\D/g,'');
      }

      Historico
        .getReverses($ctrl.filter.global.current, offset, limit)
        .then(function(data) {
          $ctrl.table.config.total = data.total;
          $ctrl.table.config.pages = Math.ceil(data.total / $ctrl.table.config.limitPerPage);
          $ctrl.table.config.reverses = $ctrl.table.config.reverses.concat(gerarNomesSituacao(data.reverses));
          // showSimpleToast();
          enableDisableLoading(['page', 'btnLoading'], null);
        })
        .catch(function(err) {
          enableDisableLoading(['page', 'btnLoading'], null);
          $ctrl.table.config.reverses = [];
          $ctrl.table.config.total = 0;
        });


      Perfil.getClienteData(localStorageService.get('user').id).then(function(user) {
        $ctrl.user = user;
      });
    }

    function gerarNomesSituacao(reverses) {
      return reverses.map(function(reverse) {

        reverse.nomeSituacao = reverse.situacao;

        if(reverse.situacao == 'Pendente')
          reverse.nomeSituacao = 'Autorização solicitada';
        if(reverse.situacao == 'AguardandoPostagem')
          reverse.nomeSituacao = 'Aguardando Postagem';

        return reverse;
      });
    }

    this.$onInit = function() {
      $ctrl._mdPanel = $mdPanel;
      $ctrl._mdToast = $mdToast;
      loadData();
      enableDisableLoading('page', true);

      if ($stateParams.tour) {
        startTour();
      }
    };

    $ctrl.filterDate = function(timestamp) {
      return $filter('myFormatDate')(timestamp);
    };

    $ctrl.fetchData = function(currentFilter) {
      if(_.isPlainObject(currentFilter)){
        $ctrl.table.config.page = 1;
        $ctrl.filter.global.current = currentFilter;
      }
      enableDisableLoading(['page', 'btnLoading'], true);

      loadData();
    };

    $ctrl.clear = function () {
      $ctrl.table.config = angular.copy($ctrl.table.reset);
      $ctrl.filter.global = angular.copy($ctrl.filter.reset);
      enableDisableLoading('page', true);
      loadData();
    };

    $ctrl.nextPage = function() {
      $ctrl.table.config.page += 1;
      $ctrl.fetchData();
    };

    $ctrl.clearSelected = function() {
      $ctrl.table.config.selected = [];
    };

    $ctrl.printLabels = function(labels) {
      enableDisableLoading('printLabels', true);
      PrintLabel
        .getLabelsToPrint(labels)
        .then(function() {
          enableDisableLoading('printLabels', null);
        })
        .catch(function() {
          enableDisableLoading('printLabels', null);
        });
    };

    function startTour() {
      const stepsConfig = [
        {
          title: 'Gerencie suas reversas',
          text: 'Solicite autorização de postagem e acompanhe as solicitações já realizadas.',
          attachTarget: () => document.querySelector('app-toolbar .mat-tab-link:nth-child(3)'),
          previous: {
            text: 'Voltar',
            action: (ev, ref) => {
              ref.close('to_prev_section');
              $state.go('encomendas', { tour: true }, { inherit: false });
            },
          }
        },
        {
          title: 'Solicite reversa',
          text: 'Clique aqui para gerar o código de autorização de postagem para seu cliente devolver a encomenda. Em caso de dúvidas, '
            + '<a href="https://mandaenuvemenvio.zendesk.com/hc/pt-br/articles/34308946697108-Envios-de-log%C3%ADstica-reversa" target="_blank">'
            + 'acesse a FAQ</a>.',
          attachTarget: () => document.querySelector('.gerar-autorizacao .btn'),
          next: {
            text: 'Ir para Devoluções',
            action: (ev, ref) => {
              ref.close('to_next_section');
              $state.go('devolucoes', { tour: true }, { inherit: false });
            }
          },
        },
      ];

      const steps = $tour.makeTour(stepsConfig);

      $tour.start(steps).subscribe();
    }

    function _getPanelPosition (evt) {
      return $ctrl._mdPanel
        .newPanelPosition()
        .relativeTo(evt.currentTarget)
        .addPanelPosition(
          $ctrl._mdPanel.xPosition.ALIGN_START,
          $ctrl._mdPanel.yPosition.ALIGN_TOPS
        );
    }

    function _close () {
      if($ctrl.isOpenDetail) {
        $ctrl.isOpenDetail.close();
      }
    }

    function _createPanel (ev, id, customPanelConfig) {
      var opts = customPanelConfig || {};
      var reverseIdSelected = _.find($ctrl.table.config.reverses, function(reverseData) {
        return reverseData.id === id;
      });

      var $elem = $(ev.currentTarget).parent().parent();
      if ($elem.is('td')) {
        $elem = $elem.parent();
      }
      $elem.addClass('bg-softgrey');

      var defaultPanelconfig = {
        attachTo: angular.element(document.body),
        template: require('./details-panel/details.html'),
        controller: 'ReverseDetailsCtrl',
        controllerAs: 'ctrl',
        panelClass: 'detail-panel',
        position: _getPanelPosition(ev),
        locals: {
          data: reverseIdSelected
        },
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2,
        onCloseSuccess: function (mdPanelRef, closeReason) {
          if (!closeReason) { return; }
          angular.element('table.m-table tr').removeClass('bg-softgrey');
        },
      };

      var config = _.assign({}, defaultPanelconfig, opts);

      if($ctrl.isOpenDetail !== null) {
        _close();
      }

      $ctrl._mdPanel
        .open(config)
        .then(function (panelRef) {
          $ctrl.isOpenDetail = panelRef;
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    $ctrl.showInsurance = function(value) {
      if (!value) {
        return 'Sem seguro';
      }
      return 'Seguro: ' + $filter('finance')(value, true);
    };

    var sideNavListener = $rootScope.$on('ticket_form:show', function(event, data){
      $ctrl.ticketForm = data;
      $ctrl.ticketForm.email = localStorageService.get('user').email;
      $mdSidenav('ticket-form').open();
    });

    $ctrl.columnFilters = {data: {}};

    $ctrl.showDeliveryPanel = function(evt) {
      var config = {
        controller: 'DeliveryFilterCtrl',
        controllerAs: '$ctrl',
        template: require('./filter-panel/delivery-filter.html'),
        locals: {
          filters: $ctrl.columnFilters.data,
        },
      };
      _createPanel(evt, null, config);
    };

    $ctrl.showStatusPanel = function(evt) {
      var config = {
        controller: 'ReversesStatusFilterCtrl',
        controllerAs: '$ctrl',
        template: require('./filter-panel/status-filter.html'),
        locals: {
          filters: $ctrl.columnFilters.data,
        },
      };
      _createPanel(evt, null, config);
    };

    $ctrl.showOriginPanel = function(evt, reverse) {
      var config = {
        controller: 'ReversesOriginCtrl',
        controllerAs: '$ctrl',
        template: require('./origin-panel/origin-panel.html'),
        panelClass: 'origin-panel',
        locals: {
          id: reverse.id,
          codigoRastreamento: reverse.codigoRastreamento
        },
      };
      _createPanel(evt, reverse.id, config);
    }

    $ctrl.showDeletePanel = function(reverse) {
      $uibModal.open({
        animation: false,
        template: require('./delete-panel/delete-panel.html'),
        controller: 'ReversesDeleteCtrl',
        controllerAs: '$ctrl',
        windowClass: 'delete-modal',
        resolve: {
          reverse: function() { return reverse }
        }
      })
      .result
      .then(function(data) {
        _showAlert('Ok, a autorização de postagem foi cancelada.');
        loadData();
        return null;
      })
      .catch(function(err) {
        _showAlert('Não foi possível cancelar a autorização de postagem, por favor tente novamente.');
        return null;
      });
    }

    // função que envia email com autorização de postagem para destinatário
    $ctrl.sendReverseAuthorization = function(reverse) {
      Historico
        .sendReverseAuthorization(reverse.id)
        .then(function(data) {
          _showAlert('Ok! A autorização foi reenviada para os e-mails cadastrados na reversa.');
          return null;
        })
        .catch(function(err) {
          _showAlert('Não foi possível reenviar a autorização para os e-mails cadastrados na reversa, por favor tente novamente.');
          return null;
        });
    };

    $ctrl.redirectToTracking = function(reverse) {
      $state.go('rastreamento', { numeroRastreio: reverse.codigoRastreamento });
    }

    $ctrl.redirectToForm = function() {
      if($ctrl.user.situacao == 'BLOQUEADO' || $ctrl.user.situacaoCadastral !== 'ATIVO') {
        $uibModal.open({
          animation: false,
          template: require('../../../modal/modal-servico-suspenso/modal-servico-suspenso.html'),
          controller: 'ModalServicoSuspensoCtrl',
          windowClass: 'agendamento-coleta-bloqueado',
          resolve: {
            redirectToEncomendas: function() { return false; },
            nomeOperacao: function() { return 'a solicitação de logística reversa'; }
          }
        });
      } else {
        $state.go('reverse-form');
      }
    }

    function _showAlert(content) {
      var toast = $mdToast.simple()
        .textContent(content)
        .highlightAction(true)
        .parent('[data-container="toast"]')
        .position('top right')
        .hideDelay(5000);

      return $mdToast.show(toast);
    }

    $scope.$watch('$ctrl.columnFilters.data', function(newValue) {
      if (!newValue || _.isEmpty(newValue)) { return; }
      $ctrl.filter.global.current = _.assign({}, $ctrl.filter.global.current, newValue.data);
      $ctrl.fetchData();
    }, true);

    $scope.$on('$destroy', function() {
      _close();
    });

    $scope.$on('$destroy', sideNavListener);
  }

  angular
    .module('mandaeApp')
    .controller('ReverseListCtrl', ReverseListCtrl);

}());
